export function initialCap(s: string) {
	return s[0].toUpperCase() + s.substr(1)
}
